import { browser } from '$app/environment';
import { firestoreDb } from '$lib/firebase';
import { logError } from '$lib/helpers/errors';
import { doc, updateDoc, Timestamp } from 'firebase/firestore';

export async function updateCart(cartDocId, data) {
	if (!browser || !cartDocId || !firestoreDb) {
		return;
	}
	console.log("Update Cart: ", cartDocId, data);
	try {
		const firestore = firestoreDb();

		await updateDoc(doc(firestore, 'cart', cartDocId), {
			...data,
			time: Timestamp.now().toDate().toLocaleTimeString('en-GB'),
			date: Timestamp.now().toDate().toLocaleDateString('en-GB'),
		});
	} catch (error) {
		console.log('update Cart error: ', error);
		logError(error, 'updateCart.js:updateCart');
	}
}
